// Mock Sessions Data
// Extracted from GuruDashboard.tsx

export interface Session {
  id: string;
  clientName: string;
  date: string;
  time: string;
  duration: number;
  status: 'scheduled' | 'completed' | 'cancelled';
  type: '1-on-1' | 'group' | 'review';
  earnings: number;
}

export const mockSessions: Session[] = [
  {
    id: '1',
    clientName: 'John Smith',
    date: '2025-01-20',
    time: '10:00 AM',
    duration: 60,
    status: 'scheduled',
    type: '1-on-1',
    earnings: 150
  },
  {
    id: '2',
    clientName: 'Maria Garcia',
    date: '2025-01-19',
    time: '2:00 PM',
    duration: 45,
    status: 'completed',
    type: 'review',
    earnings: 112.50
  },
  {
    id: '3',
    clientName: 'Diabetes Support Group',
    date: '2025-01-18',
    time: '6:00 PM',
    duration: 90,
    status: 'completed',
    type: 'group',
    earnings: 225
  },
  {
    id: '4',
    clientName: 'Sarah Johnson',
    date: '2025-01-17',
    time: '11:00 AM',
    duration: 60,
    status: 'completed',
    type: '1-on-1',
    earnings: 150
  },
  {
    id: '5',
    clientName: 'Michael Brown',
    date: '2025-01-16',
    time: '3:00 PM',
    duration: 45,
    status: 'completed',
    type: 'review',
    earnings: 112.50
  },
  {
    id: '6',
    clientName: 'Lisa Davis',
    date: '2025-01-15',
    time: '9:00 AM',
    duration: 60,
    status: 'completed',
    type: '1-on-1',
    earnings: 150
  }
]; 